var APIURL;
var REFERRALAPIURL;

var env = 'prod';

if (env === 'prod') {
  APIURL = process.env.REACT_APP_APIURL_PROD;
  REFERRALAPIURL = process.env.REACT_APP_REFERRALAPIURL_PROD;
} else if (env === 'test') {
  APIURL = process.env.REACT_APP_APIURL_TEST;
  REFERRALAPIURL = process.env.REACT_APP_REFERRALAPIURL_TEST;
} else if (env === 'dev') {
  APIURL = process.env.REACT_APP_APIURL_DEV;
  REFERRALAPIURL = process.env.REACT_APP_REFERRALAPIURL_DEV;
} else {
  APIURL = process.env.REACT_APP_APIURL_LOCAL;
  REFERRALAPIURL = process.env.REACT_APP_REFERRALAPIURL_LOCAL;
}

export { APIURL, REFERRALAPIURL };